// НА ВИДАЛЕННЯ: legacy Drawflow editor script. V2 React builder with workflow_graph
// is the canonical automation editor/runtime path now.
//import "suneditor/dist/css/suneditor.min.css";
import SUNEDITOR from "suneditor";
import plugins from "suneditor/src/plugins"; // Імпорт плагінів
import langSUNEDITOR, { se } from "suneditor/src/lang";

import Drawflow from "drawflow";
import styleDrawflow from "drawflow/dist/drawflow.min.css";

// Імпорт модуля для динамічних логічних умов
import "../../../../../app/Events/LogicCondition/logic-condition-form.js";

var animateTime = 150;
var drawflowId = "drawflow";

// Отримуємо locale prefix з URL (наприклад /uk/ або /en/)
// Locale має бути 2-символьним кодом на початку URL
const getLocalePrefix = () => {
    const pathParts = window.location.pathname.split('/').filter(part => part.length > 0);
    // Перевіряємо чи перший сегмент схожий на locale (2 символи)
    if (pathParts[0] && pathParts[0].length === 2 && /^[a-z]{2}$/.test(pathParts[0])) {
        return `/${pathParts[0]}`;
    }
    // Якщо locale немає, повертаємо порожній рядок (для localhost без locale)
    return '';
};

// Глобальна змінна для блокування одночасного створення нод
let isNodeCreationInProgress = false;

function openSmart(url) {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
        // Try to open as a popup on mobile
        const width = 600;
        const height = 600;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
        window.open(url, '_blank', `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=yes`);
    } else {
        // Desktop - just new tab
        window.open(url, "_blank");
    }
}
window.openSmart = openSmart;

/** допоміжна функція що перевіряє чи є в обєкті або масиві якісь данні */
function hasData(data) {
    return (
        data &&
        ((Array.isArray(data) && data.length > 0) ||
            (typeof data === "object" &&
                !Array.isArray(data) &&
                Object.keys(data).length > 0))
    );
}

/** функція що копіює у буфер обміну рядок */
function copyToClipboard(button) {
    // Отримуємо текст для копіювання
    const text = button.getAttribute("data-clipboard-text");

    // Створюємо тимчасовий textarea елемент
    const tempInput = document.createElement("textarea");
    document.body.appendChild(tempInput);
    tempInput.value = text; // Вставляємо текст у textarea
    tempInput.select(); // Виділяємо текст

    // Спробуємо копіювати текст у буфер обміну
    try {
        // Для сучасних браузерів
        if (document.execCommand("copy")) {
            runSuccesSubmitBtnAnimation($(button));
            //alert("Текст скопійовано!");
        } else {
            throw new Error("Unable to copy");
        }
    } catch (err) {
        alert(window.i18n.copy_failed + err.message);
    } finally {
        document.body.removeChild(tempInput); // Видаляємо тимчасовий елемент
    }
}
window.copyToClipboard = copyToClipboard;

/** обробка при кліці на кнопку "Зберегти зміни" що відповідає за заберігання назви автоматизаціі */
function saveAutomatixationName(th) {
    th = $(th);
    th.attr("disabled", "disabled").append(
        ' <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
    );

    const nameInput = $("#automatization-name");
    const name = $.trim(nameInput.val());

    const idInput = $("#automatization-id");
    const id = $.trim(idInput.val());

    if (!name || !id) {
        return false;
    }
    $.ajax({
        url: nameInput.attr("data-action"),
        method: "POST",
        data: {
            _token: $('meta[name="csrf-token"]').attr("content"), // Додаємо CSRF-токен
            id: id,
            name: name,
        },
        success: function (response) {
            runSuccesSubmitBtnAnimation(th);
        },
        error: function (xhr) {
            if (xhr.status === 422) {
                let errors = xhr.responseJSON.errors;
                console.log(errors);
            }

            th.removeAttr("disabled").find(".spinner-grow").remove();
        },
    });
}
window.saveAutomatixationName = saveAutomatixationName;

/**
 * функція викликається якщо в сабменю ноди вибрати "запустити ноду один раз" - кнопка плей
 */
function runEvent(th) {
    const t = $(th);
    const item = t.closest(".event-item");
    const settingsPopoverId = item
        .find("button.settings-event")
        .attr("data-custom-popover-id");
    const settings = $("#" + settingsPopoverId);

    var alreadyInProgress = false;
    if (!item.hasClass("in-progress")) {
        item.addClass("in-progress");
        item.find(".run-event svg use").attr("href", "#stop-icon");
    } else {
        item.removeClass("in-progress");
        item.find(".run-event svg use").attr("href", "#icon-play");
        alreadyInProgress = true;
    }

    $.ajax({
        url: window.eventRoutes.event_start, // Use global route instead of data-action
        method: "POST",
        data: {
            id: settings.find("[name='event-id']").val(),
            _token: $('meta[name="csrf-token"]').attr("content"), // Додаємо CSRF-токен
        },
        success: function (response) {
            if (response.success) {
                if (alreadyInProgress) {
                    item.attr("data-running-test-id", "");
                } else {
                    // по data-running-test-id окремий аякс запрос буде опитувати сервер про статус виконання цієї ноди
                    item.attr(
                        "data-running-test-id",
                        response.automatization_event_task_id
                    );
                    
                }
            } else {
                if (!alreadyInProgress) { 
                    item.removeClass("in-progress");
                    item.find(".run-event svg use").attr("href", "#icon-play");
                } else {
                    item.addClass("in-progress");
                    item.find(".run-event svg use").attr("href", "#stop-icon");
                }

                if (response.error) {
                    alert(response.error);
                }
            }
        },
        error: function (xhr) {
            if (!alreadyInProgress) { 
                item.removeClass("in-progress");
                item.find(".run-event svg use").attr("href", "#icon-play");
            } else {
                item.addClass("in-progress");
                item.find(".run-event svg use").attr("href", "#stop-icon");
            }

            if (xhr.status !== 200) {
                alert(window.i18n.server_error);
            }
        },
    });
}
window.runEvent = runEvent;

/**
 * при зберіганні форми будь якої ноди - відправляємо аяксом данні на сервер
 */
$("body").on("submit", ".custom-popover form[data-event-form]", function (e) {
    e.preventDefault();
    const form = $(this);

    eventFormSubmit(form).catch(() => {
        // Помилка вже оброблена в eventFormSubmit (показано форм ерори)
    });
});

/**
 * допоміжна функція що поверне цифрофе ІД ноди що використовується для цієї форми
 * бо форма в окремому місці в ДОМ в модальному вікні
 */
function getNodeIdByNodeSetiingsForm(form) {
    // взнаємо ІД ноди на полотні
    var nodeId = $(
        ".events-item-wraper [data-custom-popover-id='" +
        form.closest("[data-custom-popover]").attr("id") +
        "']"
    )
        .closest(".drawflow-node")
        .attr("id");

    return separateNumericNodeId(nodeId);
}

/*
function getChildNodes(editor, nodeId, result = new Set()) {
    const data = editor.drawflow.drawflow.Home.data[nodeId];

    if (!data || !data.outputs) return result;

    for (const outputName in data.outputs) {
        const connections = data.outputs[outputName].connections;

        connections.forEach(conn => {
            const childId = conn.node;

            if (!result.has(childId)) {
                result.add(childId);

                // рекурсивно шукаємо далі
                getChildNodes(editor, childId, result);
            }
        });
    }

    return result;
}
*/

function getParentNodes(editor, nodeId, result = new Set()) {
    const data = editor.drawflow.drawflow.Home.data[nodeId];

    if (!data || !data.inputs) return result;

    for (const inputName in data.inputs) {
        const connections = data.inputs[inputName].connections;

        connections.forEach(conn => {
            const parentId = conn.node;

            if (!result.has(parentId)) {
                result.add(parentId);

                // рекурсивно піднімаємося вище
                getParentNodes(editor, parentId, result);
            }
        });
    }

    return result;
}


/**
 * метод, що в реальному часі генерує усі доступні данні для використання
 * на тому чи іншому кроці(ноді)
 * данні бере на основі тих даних що вже містяться у всіх попередніх нодах
 * в розілі "Доступні данні"
 */
function generateAvailableDataToUse() {
    // перебираємо усі ноди
    $("#" + drawflowId + " .drawflow-node").each(function () {
        var node = $(this);
        var nodeId = separateNumericNodeId(node.attr("id"));
        var nodeSettingBtn = node.find(".actions .settings-event");
        var nodeSettingModalId =  nodeSettingBtn.attr("data-custom-popover-id");
        var nodeSettingModal = $("#" + nodeSettingModalId);
        var availableDataTab = nodeSettingModal.find(".custom-tabs .tab-pane[data-tab=\"tab-available-data\"] .content-inner");

        // дивимисоя чи є і поточної ноди - батьківські
        var parentNodes = getParentNodes(editorDrawflow, nodeId);
        // перебираємо усі попередні(батьківські) ноди і додаємо іх останні виконання логів - як данні для використання
        var htmlToAdd = "";
        for (const id of parentNodes) {
            var currentNode = $("#" + drawflowId + " .drawflow-node#node-" + id);
            var currentEvent = currentNode.find(".event-item");
            var eventIco = currentEvent.find(".event-icon.icon");
            
            const modalSettingsId = currentEvent
                .find(".actions .settings-event")
                .attr("data-custom-popover-id");

            const modalId = currentEvent
                .find(".actions .logs-event")
                .attr("data-custom-popover-id");

            // якщо є модалка з логами
            const modal = $("#" + modalId);

            if (modal.length) {
                // отримуємо доступні для використання данні
                const dataDiv = modal.find("details").eq(0);
                if (dataDiv.length) { // і якщо є логи
                    // формуємо HTML для додавання
                    let logClone = dataDiv.clone();
                    if (eventIco && eventIco[0]) {
                        // додаємо іконку події в самері details
                        logClone
                            .find("summary")
                            .prepend(eventIco[0].outerHTML);
                    }
                        
                    htmlToAdd += logClone[0].outerHTML;
                }

            }
        }

        if (htmlToAdd) {
            availableDataTab.html(htmlToAdd);

            // звертаємо усі details якщо вони розгорнуті
        nodeSettingModal
            .find(
                '.tab-content .tab-pane[data-tab="tab-available-data"] details[open]'
            )
            .removeAttr("open");
        }
        

                     
    });
}
window.generateAvailableDataToUse = generateAvailableDataToUse;


/**
 * Перевіряє чи є на полотні drawflow ізольовані ноди
 * (ноди що не з'єднані з будь-якими іншими нодами)
 * 
 * @returns {boolean} true - якщо є ізольовані ноди, false - якщо всі ноди з'єднані
 */
function hasBrokeDrawflow() {
    const drawflowData = editorDrawflow.export();
    
    if (!drawflowData || !drawflowData.drawflow || !drawflowData.drawflow.Home || !drawflowData.drawflow.Home.data) {
        return false; // Немає даних - немає проблем
    }
    
    const nodes = drawflowData.drawflow.Home.data;
    const nodeIds = Object.keys(nodes);
    
    // Якщо менше 2 нод - не може бути з'єднань
    if (nodeIds.length < 2) {
        return false; // Якщо є одна нода - вона ізольована
    }
    
    // Перевіряємо кожну ноду
    for (const nodeId of nodeIds) {
        const node = nodes[nodeId];
        let hasConnections = false;
        
        // Перевіряємо вихідні з'єднання (outputs)
        if (node.outputs) {
            for (const outputKey in node.outputs) {
                const output = node.outputs[outputKey];
                if (output.connections && output.connections.length > 0) {
                    hasConnections = true;
                    break;
                }
            }
        }
        
        // Перевіряємо вхідні з'єднання (inputs)
        if (!hasConnections && node.inputs) {
            for (const inputKey in node.inputs) {
                const input = node.inputs[inputKey];
                if (input.connections && input.connections.length > 0) {
                    hasConnections = true;
                    break;
                }
            }
        }
        
        // Якщо нода не має жодних з'єднань - це ізольована нода
        if (!hasConnections) {
            console.warn(`Знайдено ізольовану ноду: ${nodeId}`, node);
            return true;
        }
    }
    
    return false; // Всі ноди мають з'єднання
}
window.hasBrokeDrawflow = hasBrokeDrawflow;

/**
 * Повертає кількість нод, що наразі додані на полотно drawflow
 * 
 * @returns {number} - кількість нод на полотні
 */
function getNodesCount() {
    const drawflowData = editorDrawflow.export();
    
    if (!drawflowData || !drawflowData.drawflow || !drawflowData.drawflow.Home || !drawflowData.drawflow.Home.data) {
        return 0; // Немає даних - немає нод
    }
    
    const nodes = drawflowData.drawflow.Home.data;
    return Object.keys(nodes).length;
}
window.getNodesCount = getNodesCount;


// допоміжна функіця що чекає коли всі анімаціі елемента завершаться
function waitAllAnimation(element) {
    return new Promise((resolve) => {
        let animationEnded = false;
        let transitionEnded = false;

        // Перевірка завершення
        function checkCompletion() {
            if (animationEnded && transitionEnded) {
                resolve(true);
            }
        }

        // Обробник закінчення анімації
        const animationEndHandler = () => {
            animationEnded = true;
            element.removeEventListener("animationend", animationEndHandler);
            checkCompletion();
        };

        // Обробник закінчення переходу
        const transitionEndHandler = () => {
            transitionEnded = true;
            element.removeEventListener("transitionend", transitionEndHandler);
            checkCompletion();
        };

        // Додаємо обробники подій
        element.addEventListener("animationend", animationEndHandler);
        element.addEventListener("transitionend", transitionEndHandler);

        // Отримуємо стилі елемента
        const computedStyles = window.getComputedStyle(element);

        // Отримуємо тривалість анімації та переходу
        const animationDuration =
            parseFloat(computedStyles.animationDuration) || 0;
        const transitionDuration =
            parseFloat(computedStyles.transitionDuration) || 0;

        // Якщо обидві тривалості дорівнюють 0, одразу викликаємо resolve
        if (animationDuration === 0 && transitionDuration === 0) {
            animationEnded = true;
            transitionEnded = true;
            checkCompletion();
        } else {
            // Встановлюємо таймаут на випадок, якщо події не викликаються
            const maxDuration = Math.max(animationDuration, transitionDuration);
            setTimeout(() => {
                animationEnded = true;
                transitionEnded = true;
                checkCompletion();
            }, maxDuration * 1000); // перетворюємо тривалість у мілісекунди
        }
    });
}

// при натисканні на кнопку видалення ноди
async function removeEvent(th, q, confirmStatus = true) {
    if ((confirmStatus && confirm(q)) || !confirmStatus) {
        const currentItem = $(th).closest(".event-item");

    
        let eventId = currentItem.attr("data-event-id");
        eventId = eventId * 1;

        // якщо ІД існує - відправляємо запрос на видалленя
        if (eventId) {
            $.ajax({
                url: window.eventRoutes.event_destroy, // Use global route instead of data-action
                method: "DELETE",
                data: {
                    id: eventId,
                    _token: $('meta[name="csrf-token"]').attr("content"), // Додаємо CSRF-токен
                },
                success: function (response) {
                    // видаляємо поповери цієї ноди з ДОМ
                    currentItem.find(".actions [data-custom-popover-id]").each(function() {
                        var popoverId = $(this).attr("data-custom-popover-id");
                        if (popoverId) {
                            $("#" + popoverId).remove();
                        }
                    });


                    generateAvailableDataToUse();
                },
                error: function (xhr) {
                    if (xhr.status === 422) {
                        let errors = xhr.responseJSON.errors;
                        console.log(errors);
                    }
                },
            });
        }

        const parent = $(th).closest(".events-item-wraper");
        const countItems = parent.find(".event-item").length;
        currentItem.addClass("remove"); // анімуємо видадення
        await waitAllAnimation(currentItem[0]); // чекаємо поки скінчіться анімація

        var parentNode = currentItem.closest(".parent-node");
        currentItem.remove();
        if (countItems === 1) {
            // якщо в врапері була всього 1 нода - видаляємо і врапер
            parent.remove();
            if (parentNode.length) {
                var nodeId = parentNode.find(".drawflow-node").attr("id");

                editorDrawflow.removeNodeId(nodeId);
                editorDrawflow.removeConnectionNodeId(nodeId);
                parentNode.remove();
            }
        }
    }
}
window.removeEvent = removeEvent;

/**
 * проанімує галочку і зробить кнопку знову активною
 */
function runSuccesSubmitBtnAnimation(submit, callback) {
    submit.find(".spinner-grow").remove();

    submit.append(
        ' <svg class="icon-scale-in" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16"><path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/></svg>'
    );
    const successIco = submit.find(".icon-scale-in");

    setTimeout(function () {
        successIco.removeClass("icon-scale-in").addClass("icon-scale-out");
    }, 1500);
    setTimeout(function () {
        submit.removeAttr("disabled").find(".icon-scale-out").remove();

        // Викликаємо callback після завершення всіх операцій
        if (typeof callback === "function") {
            callback();
        }
    }, 1501);
}

// додає повідомлення помилок в форму ноди
function showFormErrors(form, errors) {
    let firstInvalidField = null;
    let firstVisibleElement = null;

    if (errors) {
        Object.keys(errors).forEach(function (fieldName) {
            let fieldNameOriginal = fieldName;
            let fieldNameTrim = fieldName.split(".");
            let eq = 0;
            if (fieldNameTrim.length > 1) {
                fieldName = fieldNameTrim[0] + "[]";
                eq = fieldNameTrim[1];
            }

            // Знаходимо відповідне поле
            let formControl = form.find(`[name="${fieldName}"]`).eq(eq);
            
            if (!formControl.length) {
                return; // Пропускаємо якщо поле не знайдено
            }

            // Знайдемо або створимо .invalid-feedback
            let errorElement = formControl.siblings(".invalid-feedback");
            if (!errorElement.length) {
                errorElement = $('<div class="invalid-feedback"></div>');
                formControl.after(errorElement);
            }

            // Встановлюємо текст помилки
            errorElement.html(errors[fieldNameOriginal][0]);
            formControl.addClass("is-invalid");

            // Запам'ятовуємо перше інвалідне поле
            if (!firstInvalidField) {
                firstInvalidField = formControl;
                
                // Знаходимо видимий елемент для скролу
                if (formControl.is(':visible')) {
                    // Якщо поле видиме - використовуємо його
                    firstVisibleElement = formControl;
                } else {
                    // Якщо поле приховане (WYSIWYG, hidden textarea тощо)
                    // Шукаємо видимий wrapper
                    
                    // 1. Спробуємо знайти Sun Editor
                    let sunEditor = formControl.siblings('.sun-editor');
                    if (sunEditor.length && sunEditor.is(':visible')) {
                        firstVisibleElement = sunEditor;
                    } else {
                        // 2. Шукаємо найближчий видимий wrapper
                        let wrapper = formControl.closest('.form-group, .textarea-inner, .input-group');
                        if (wrapper.length && wrapper.is(':visible')) {
                            firstVisibleElement = wrapper;
                        } else {
                            // 3. Fallback - використовуємо саме поле
                            firstVisibleElement = formControl;
                        }
                    }
                }
            }
        });
    }

    // Прокручуємо до першого поля з помилкою
    if (firstVisibleElement) {
        // Шукаємо .content-inner в активному табі або в формі
        let container = form.find(".tab-pane.active .content-inner");
        
        if (!container.length) {
            container = form.find(".content-inner");
        }
        
        if (container.length) {
            scrollToElementInContainer(
                container,
                firstVisibleElement,
                100
            );
        } else {
            // Якщо .content-inner не знайдено, скролимо саму форму
            firstVisibleElement[0].scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center' 
            });
        }
    }
}

// Спеціальний обробник помилок для LogicCondition форми
function showLogicConditionErrors(form, errors) {
    // Очищаємо попередні помилки
    form.find('.is-invalid').removeClass('is-invalid');
    form.find('.invalid-feedback').remove();
    
    let firstErrorElement = null;
    
    Object.keys(errors).forEach(function(errorPath) {
        const errorMessage = errors[errorPath][0];
        
        // Парсимо шлях помилки: logic_structure.groups.0.conditions.1.left_operand
        const pathMatch = errorPath.match(/logic_structure\.groups\.(\d+)\.conditions\.(\d+)\.(.+)/);
        
        if (pathMatch) {
            const groupIndex = parseInt(pathMatch[1]);
            const conditionIndex = parseInt(pathMatch[2]);
            const fieldName = pathMatch[3]; // left_operand, comparison_operator, right_operand
            
            // Знаходимо всі групи в формі
            const groups = form.find('.logic-group');
            const targetGroup = groups.eq(groupIndex);
            
            if (targetGroup.length) {
                // Знаходимо всі умови в групі
                const conditions = targetGroup.find('.condition-row');
                const targetCondition = conditions.eq(conditionIndex);
                
                if (targetCondition.length) {
                    let targetField = null;
                    
                    // Визначаємо яке поле має помилку
                    if (fieldName === 'left_operand') {
                        targetField = targetCondition.find('.left-operand');
                    } else if (fieldName === 'comparison_operator') {
                        targetField = targetCondition.find('.operator-select select');
                    } else if (fieldName === 'right_operand') {
                        targetField = targetCondition.find('.right-operand');
                    }
                    
                    if (targetField && targetField.length) {
                        // Додаємо клас помилки
                        targetField.addClass('is-invalid');
                        
                        // Створюємо елемент з текстом помилки
                        const errorElement = $('<div class="invalid-feedback d-block"></div>').text(errorMessage);
                        targetField.after(errorElement);
                        
                        // Запам'ятовуємо перше поле з помилкою
                        if (!firstErrorElement) {
                            firstErrorElement = targetField;
                        }
                    }
                }
            }
        } else if (errorPath === 'logic_structure') {
            // Загальна помилка структури - показуємо вгорі форми
            const alertElement = $(`
                <div class="alert alert-danger alert-dismissible fade show" role="alert">
                    ${errorMessage}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            `);
            form.find('.logic-condition-dynamic-form').prepend(alertElement);
        }
    });
    
    // Скролимо до першого поля з помилкою
    if (firstErrorElement) {
        const container = form.find(".tab-pane.active .content-inner");
        if (container.length) {
            scrollToElementInContainer(container, firstErrorElement, 100);
        } else {
            firstErrorElement[0].scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center' 
            });
        }
    }
}

// допоміжний метод для showFormErrors, щоб проскролити до поля з помилкою
function scrollToElementInContainer(container, element, offset = 50) {
    const containerEl = container[0];
    const elementEl = element[0];

    const containerScrollTop = containerEl.scrollTop;
    const containerHeight = containerEl.clientHeight;
    const scrollHeight = containerEl.scrollHeight;

    const elementOffsetTop = elementEl.offsetTop;

    const isReversed =
        getComputedStyle(containerEl).flexDirection === "column-reverse";

    let scrollTarget;

    if (isReversed) {
        const elementBottom = scrollHeight - elementOffsetTop;
        scrollTarget = scrollHeight - elementBottom - containerHeight + offset;
    } else {
        scrollTarget = elementOffsetTop - offset;
    }

    container.animate({ scrollTop: scrollTarget }, animateTime);
}

/**
 * обробчик відправки форм нод в кастомних поповерах
 */
async function eventFormSubmit(form, node_id = null, skipClosePopover = false) {
    if (!node_id) node_id = getNodeIdByNodeSetiingsForm(form);

    // ІД поповера в середині якого форма
    const popoverId = form.closest(".custom-popover").attr("id");

    // вибираємо ноду на полотні
    const currentEvent = $(
        "#" +
        drawflowId +
        " .event-item .actions [data-custom-popover-id='" +
        popoverId +
        "']"
    ).closest(".event-item");

    // вибираємо кнопку сабміта форми
    const submit = form.find("button[type='submit']");
    submit
        .attr("disabled", "disabled")
        .append(
            ' <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
        );

    // видаляємо усі помилки валідаціі якщо вони є
    form.find(".invalid-feedback").html("");
    form.find(".is-invalid").removeClass("is-invalid");

    // Отримуємо серіалізовані дані у вигляді масиву
    var formData = form.serializeArray();

    // Додаємо нові параметри в серіалізовані дані
    const currentAutomatizationName = $("#automatization-name").val();
    formData.push({
        name: "automatization-name",
        value: currentAutomatizationName,
    });

    // Додаємо ІД ноди для якої буде створено запис в БД
    formData.push({
        name: "node_id",
        value: node_id,
    });

    const currentAutomatizationID = $("#automatization-id").val();
    formData.push({
        name: "automatization-id",
        value: currentAutomatizationID,
    });

    var serializedData = $.param(formData);

    // відпрявояємо форму
    return new Promise((resolve, reject) => {
        $.ajax({
            url: form.attr("action"),
            method: form.attr("method"),
            data: serializedData,
            success: function (response) {
                if (response.success) {
                    // оновлюємо скритий інпут з ІД ноди
                    const eventIdInput = form.find("[name='event-id']");
                    let eventId = eventIdInput.length
                        ? Number(eventIdInput.val())
                        : 0;
                    if (!eventId) {
                        // якщо ще немає ІД - виставляємо
                        eventIdInput.val(response.new_event_id);
                        currentEvent.attr(
                            "data-event-id",
                            response.new_event_id
                        );
                    }

                    // прописуємо назву автоматизаціі якщо вона була пуста
                    if (
                        !currentAutomatizationName &&
                        response.automatiozation_name
                    ) {
                        $("#automatization-name").val(
                            response.automatiozation_name
                        );
                    }

                    /*
                    // активуємо кнопку "запустити один раз"
                    currentEvent
                        .find(".run-event[disabled]")
                        .removeAttr("disabled");
                    */

                    runSuccesSubmitBtnAnimation(submit, function () {
                        // Закриваємо попап тільки якщо не передано skipClosePopover
                        if (!skipClosePopover) {
                            closePopover(form[0]);
                        }
                    });

                    // резолвимо проміс з необхідними даними
                    resolve({
                        new_event_id: response.new_event_id,
                        form,
                        response,
                    });
                } else {
                    // reject з помилкою сервера
                    reject(response);
                }
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    const errors = xhr.responseJSON.errors;
                    
                    // Перевіряємо чи це LogicCondition форма
                    const isLogicConditionForm = form.find('.logic-condition-dynamic-form').length > 0;
                    
                    if (isLogicConditionForm) {
                        showLogicConditionErrors(form, errors);
                    } else {
                        showFormErrors(form, errors);
                    }
                    
                    submit
                        .removeAttr("disabled")
                        .find(".spinner-grow")
                        .remove();
                }
                reject(xhr);
            },
        });
    });
}

/**
 * функція калькулює кооринати наступної ноди - щоб додати поруч
 */
/**
 * Знаходить вільну позицію для нової ноди на полотні
 * Шукає найближче вільне місце без перекриття з існуючими нодами
 */
function getNewNodePosition() {
    const container = document.getElementById(drawflowId);

    // Розміри ноди
    const nodeWidth = 250;
    const nodeHeight = 150;
    const padding = 30; // Відступ між нодами

    // Стартові координати
    const startX = 10;
    const startY = 120;

    // Отримуємо всі ноди
    const nodes = Object.values(
        editorDrawflow?.drawflow?.drawflow?.[editorDrawflow.module]?.data || {}
    );

    // Якщо немає нод - повертаємо стартову позицію
    if (nodes.length === 0) {
        return { newX: startX, newY: startY };
    }

    // Динамічна ширина полотна
    const canvasWidth = container.offsetWidth;

    /**
     * Перевіряє чи перекривається позиція з існуючими нодами
     */
    function isPositionFree(x, y) {
        for (const node of nodes) {
            const nodeX = node.pos_x;
            const nodeY = node.pos_y;

            // Перевіряємо перекриття з урахуванням padding
            const overlapX = x < nodeX + nodeWidth + padding && x + nodeWidth + padding > nodeX;
            const overlapY = y < nodeY + nodeHeight + padding && y + nodeHeight + padding > nodeY;

            if (overlapX && overlapY) {
                return false; // Позиція зайнята
            }
        }
        return true; // Позиція вільна
    }

    // Якщо є батьківська нода - пробуємо розмістити поруч з нею
    if (window.parent_plus_node_id) {
        const parentId = String(window.parent_plus_node_id).replace('node-', '');
        const parentNode = nodes.find(n => String(n.id) === parentId);

        if (parentNode) {
            // 1. Пробуємо праворуч
            let tryX = parentNode.pos_x + nodeWidth + padding;
            let tryY = parentNode.pos_y;
            if (isPositionFree(tryX, tryY)) return { newX: tryX, newY: tryY };

            // 2. Пробуємо знизу
            tryX = parentNode.pos_x;
            tryY = parentNode.pos_y + nodeHeight + padding;
            if (isPositionFree(tryX, tryY)) return { newX: tryX, newY: tryY };

            // 3. Пробуємо праворуч-знизу (діагональ)
            tryX = parentNode.pos_x + nodeWidth + padding;
            tryY = parentNode.pos_y + nodeHeight + padding;
            if (isPositionFree(tryX, tryY)) return { newX: tryX, newY: tryY };
        }
    }

    // Спочатку пробуємо знайти місце праворуч від останньої ноди
    const lastNode = nodes.reduce((prev, n) => {
        if (n.pos_y > prev.pos_y) return n;
        if (n.pos_y === prev.pos_y && n.pos_x > prev.pos_x) return n;
        return prev;
    });

    let newX = lastNode.pos_x + nodeWidth + padding;
    let newY = lastNode.pos_y;

    // Якщо позиція вільна і не виходить за межі - повертаємо її
    if (newX + nodeWidth <= canvasWidth && isPositionFree(newX, newY)) {
        return { newX, newY };
    }

    // Якщо не підходить - шукаємо вільне місце по сітці
    const stepX = nodeWidth + padding;
    const stepY = nodeHeight + padding;
    const maxColumns = Math.floor(canvasWidth / stepX);

    // Шукаємо вільне місце рядок за рядком
    for (let row = 0; row < 20; row++) { // Максимум 20 рядків
        const y = startY + row * stepY;

        for (let col = 0; col < maxColumns; col++) {
            const x = startX + col * stepX;

            if (isPositionFree(x, y)) {
                return { newX: x, newY: y };
            }
        }
    }

    // Якщо не знайшли вільного місця (малоймовірно) - додаємо в кінець
    const maxY = Math.max(...nodes.map((n) => n.pos_y));
    return { 
        newX: startX, 
        newY: maxY + nodeHeight + padding 
    };
}

/**
 * натискання на кнопку "закрити" в поповері
 */
function closePopover(th) {
    const popover = $(th).closest(".custom-popover");

    if (popover.hasClass("show")) {
        popover.removeClass("show");
    }

    popover.fadeOut(animateTime);
    setTimeout(function () {
        popover.removeAttr("data-open");
    }, animateTime);
}
window.closePopover = closePopover;

/**
 * функція, що ініціалізує візуальний редактор для полів
 * в середині модалки де є текстаріі з атрибутом  data-wysiwyg="true"
 */
function initWysiwyg(modal) {
    // Створюємо плагін для кнопки "Spoiler" в редакторі
    const spoilerButton = {
        name: "spoiler",
        display: "command",
        title: "Спойлер",
        buttonClass: "",
        innerHTML: "&#8759;&#8759;&#8759;",
        add: function (core, targetElement) {
            const context = core.context;
            context.spoiler = { targetButton: targetElement };
        },
        action: function () {
            const core = this;
            const selection = core.getSelection();

            if (!selection.rangeCount) return;

            const range = selection.getRangeAt(0); // Отримуємо поточний range
            const selectedText = range.toString();

            // Створюємо елемент спойлера
            const spoilerElement = document.createElement("tg-spoiler");
            spoilerElement.textContent =
                selectedText.length > 0 ? selectedText : "Спойлер";

            // Використовуємо внутрішні методи SunEditor для вставки та синхронізації
            core.insertNode(spoilerElement, null, true);
            
            // Якщо текст не був виділений, переміщуємо курсор всередину спойлера
            if (selectedText.length === 0) {
                const newRange = document.createRange();
                newRange.selectNodeContents(spoilerElement);
                newRange.collapse(false); // Переміщуємо курсор в кінець спойлера
                
                const selectionObj = window.getSelection();
                selectionObj.removeAllRanges();
                selectionObj.addRange(newRange);
            }

            // Повідомляємо редактор про зміни для негайної синхронізації
            core.history.push(false);
        },
    };

    // Ініціалізація редактора
    const areas = modal[0].querySelectorAll('[data-wysiwyg="true"]');

    // якщо є де інізіалізувати - запускаємо
    if (areas.length > 0) {
        areas.forEach((area) => {
            if (!area.sunEditor) {
                // ініціалізуємо тільки якщо ще не ініціалізовано
                area.sunEditor = SUNEDITOR.create(area, {
                    lang: langSUNEDITOR.ua,
                    buttonList: [
                        ["undo"],
                        [
                            "bold",
                            "underline",
                            "italic",
                            "strike",
                            "link",
                            "spoiler",
                        ],
                        ["codeView", "fullScreen"], // Додаємо кнопку спойлера
                    ],
                    addTagsWhitelist: "tg-spoiler", // Додаємо кастомний тег до списку дозволених
                    plugins: [
                        plugins.link, // Явне підключення плагіна посилань
                        spoilerButton, // Додаємо плагін
                    ],
                    //defaultTag: "div", // Налаштовуємо тег за замовчуванням на div
                    //lineBreaker: "br", // Встановлюємо розрив рядка на br
                });
                area.sunEditor.onChange = function (contents) {
                    console.log("Змінений вміст:", contents);

                    area.value = contents;
                };
            }
        });
    } else {
        console.log("No elements to run wysiwyg.");
    }
}

/**
 *
 * @param {*} length
 * @returns
 * генерує рандомний рядок на основі мікротайм
 */
function randomString(length = 5) {
    const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const now = performance.now(); // точний час
    let seed = Math.floor(now * 1000);

    return Array.from({ length }, () => {
        seed = (seed * 9301 + 49297) % 233280; // простий LCG генератор
        return chars[Math.floor((seed / 233280) * chars.length)];
    }).join("");
}

/**
 * при додаванні ноди через "плюс" в меню вже доданих НОД
 * тут ми зберігаємо ІД цієї ноди - де був натиснутий "плюс"
 * щоб потім після додавання ноди на полотни - зв'язати по ІД дві ноди
 */
window.parent_plus_node_id = 0;
window.parent_plus_node_output_id = 0;
function setParentNodeGloablId(th, output = null) {
    var th = $(th);

    window.parent_plus_node_id = 0;
    var parent = th.closest(".drawflow-node");
    if (parent.length) {
        var parentId = parent.attr("id");
        if (parentId) {
            window.parent_plus_node_id = parentId;
        }
    }

    if (output) {
        const match = output.className.match(/output_(\d+)/);

        window.parent_plus_node_output_id = 1;
        if (match) {
            const number = parseInt(match[1], 10);
            window.parent_plus_node_output_id = number;
        }
    }
}
window.setParentNodeGloablId = setParentNodeGloablId;

/**
 * закриває/ховає усі кастомні поповери
 */
function closeAllPopovers() {
    const popovers = $(".custom-popover:visible");

    // повертаємо проміс, щоб можна було чекати завершення
    return new Promise((resolve) => {
        popovers
            .fadeOut(150, function () {
                $(this).removeClass("show");
                $(this).removeAttr("data-open");
            })
            .promise()
            .done(resolve); // promise().done() гарантує завершення всіх елементів
    });
}
window.closeAllPopovers = closeAllPopovers;

/**
 * допоміжна функція щоб виділити чисти ІД ноди з текстового ІД
 */
function separateNumericNodeId(id) {
    return parseInt(id.replace("node-", ""), 10);
}

/**
 * якщо модалка намагається викликатися для ноди на полотні
 * а в ноді ще не встановлені атрибути модалок що зв'язані
 * значить можна спробувати це зробити - дізнавшись реалні зв'язані ІД
 * через данні що збережені в ноді
 */
function tryToGetIdBydrawflowNodeId(th, popoverName) {
    var customPopoverId = null;
    const drawflowNode = th.closest(".drawflow-node");
    if (drawflowNode.length) {
        const numericId = separateNumericNodeId(drawflowNode.attr("id"));
        const event_id =
            editorDrawflow?.export()?.drawflow?.Home?.data[numericId]?.data
                ?.event_id;
        if (event_id) {
            customPopoverId =
                "id-custom-popover-" + popoverName + "--" + event_id;

            th.attr("data-custom-popover-id", customPopoverId);
        }
    }
    return customPopoverId;
}


async function toggleCustomPopover(target, popoverName, show = true) {
    const th = $(target);

    // закриваємо усі відкриті поповери
    await closeAllPopovers();

    let customPopoverId = th.attr("data-custom-popover-id");

    if (!customPopoverId) {
        customPopoverId = tryToGetIdBydrawflowNodeId(th, popoverName);
    }

    // шукаємо поповер у DOM
    let popover = customPopoverId ? $("#" + customPopoverId) : $();

    // якщо поповер вже існує
    if (popover.length) {
        if (popover.is(":visible")) {
            // ховаємо і чекаємо завершення
            await new Promise((resolve) => {
                popover.fadeOut(animateTime, function () {
                    $(this).removeAttr("data-open");
                    resolve();
                });
            });
        } else if (show) {
            // показуємо і чекаємо завершення
            await new Promise((resolve) => {
                popover.css("display", "flex").fadeIn(animateTime, function () {
                    $(this).attr("data-open", "true");
                    resolve();
                });
            });
            // ініціалізація редактора
            initWysiwyg(popover);
            
            // Ініціалізація logic condition форм якщо є
            if (typeof window.initLogicConditionForms === 'function') {
                window.initLogicConditionForms(popover[0]);
            }
        }

        
        return popover;
    } else {
        // якщо поповера ще немає — завантажуємо через AJAX
        
        // Перевірка на undefined popoverName
        if (!popoverName) {
            console.error('toggleCustomPopover: popoverName is undefined');
            return;
        }
        
        // Спеціальні non-event поповери (first-step) - шукаємо в DOM замість AJAX
        const nonEventPopovers = ['first-step'];
        if (nonEventPopovers.includes(popoverName)) {
            // Використовуємо старий метод клонування з DOM
            const template = $(
                ".d-none [data-custom-popover='" + popoverName + "']"
            );
            if (!template.length) {
                console.error(`Template for "${popoverName}" not found in DOM`);
                return;
            }

            const newId = "id-custom-popover-" + popoverName + "--" + randomString();
            const clone = template.clone().hide().attr("id", newId);
            th.attr("data-custom-popover-id", newId);
            $("body").append(clone);

            if (show) {
                await new Promise((resolve) => {
                    clone.css("display", "flex").fadeIn(animateTime, function () {
                        clone.attr("data-open", "true");
                        resolve();
                    });
                });
                initWysiwyg(clone);
                
                // Ініціалізація logic condition форм якщо є
                if (typeof window.initLogicConditionForms === 'function') {
                    window.initLogicConditionForms(clone[0]);
                }
            }

            return clone;
        }
        
        // Визначаємо тип модалки та назву події
        let modalType = 'settings';
        let cleanEventName = popoverName;
        
        // Якщо назва закінчується на -log-popover або містить -log, це logs modal
        if (popoverName.endsWith('-log-popover')) {
            modalType = 'logs';
            cleanEventName = popoverName.replace('-log-popover', '');
        } else if (popoverName.includes('-log')) {
            // Наприклад: telegram-source-log => telegram-source
            modalType = 'logs';
            // Знаходимо останнє входження '-log' і видаляємо все після нього
            const logIndex = popoverName.lastIndexOf('-log');
            cleanEventName = popoverName.substring(0, logIndex);
        }

        let clone;
        try {
            const localePrefix = getLocalePrefix();
            const response = await $.ajax({
                url: `${localePrefix}/cabinet/automatization/event/render-modal/${cleanEventName}/${modalType}`,
                method: 'GET',
                dataType: 'json'
            });
            
            const newId = "id-custom-popover-" + popoverName + "--" + randomString();
            clone = $(response.html).hide().attr("id", newId);
            th.attr("data-custom-popover-id", newId);
            $("body").append(clone);
            
        } catch (error) {
            console.error('Failed to load popover:', error);
            console.error('Event name:', cleanEventName, 'Modal type:', modalType);
            return;
        }

        if (show) {
            await new Promise((resolve) => {
                clone.css("display", "flex").fadeIn(animateTime, function () {
                    clone.attr("data-open", "true");
                    resolve();
                });
            });
            initWysiwyg(clone);
            
            // Ініціалізація logic condition форм якщо є
            if (typeof window.initLogicConditionForms === 'function') {
                window.initLogicConditionForms(clone[0]);
            }
        }


        return clone;
    }
}

window.toggleCustomPopover = toggleCustomPopover;

/**
 *
 * @param {*} th
 *
 * основний метод що додає новий ноду на полотно
 */
function add_source(th) {
    // при додаванні нової ноди на полотно - закриваємо усі поповери
    closeAllPopovers();

    // додаємо кнопку ноди (телеграм або чатGPT або інщі) в панель нод
    addNode(th);
}
window.add_source = add_source;

let isDraggingOutput = false;

$("body").on("touchstart", ".drawflow .parent-node .outputs .output", function () {
    isDraggingOutput = false;
});

$("body").on("touchmove", ".drawflow .parent-node .outputs .output", function () {
    isDraggingOutput = true;
});

$("body").on("click touchend", ".drawflow .parent-node .outputs .output", function (e) {
    if (e.type === 'touchend' && isDraggingOutput) {
        return;
    }

    // Prevent double firing
    if (e.type === 'touchend') {
        $(this).data('lastTouch', new Date().getTime());
    } else if (e.type === 'click') {
        const lastTouch = $(this).data('lastTouch');
        if (lastTouch && new Date().getTime() - lastTouch < 500) {
            return;
        }
    }

    var th = $(this);
    var addBtn = th.closest(".parent-node").find(".event-item .actions .add-event");
    
    setParentNodeGloablId(addBtn[0], this); 
    toggleCustomPopover(addBtn[0], 'first-step');
});

// функція додає нову ноду на панель нод
async function addNode(th) {
    const errorMessage = "Сталася помилка, будь ласка повторіть спробу пізніше";

    // БЛОКУВАННЯ: якщо вже йде створення ноди - не дозволяємо повторний виклик
    if (isNodeCreationInProgress) {
        console.warn('Node creation already in progress, please wait...');
        return false;
    }

    // полотно drawflow
    const drawflow = $("#drawflow"); // полотно з усіма нодами
    if (!drawflow.length) {
        return false;
    }

    // Встановлюємо прапорець що створення почалось
    isNodeCreationInProgress = true;

    // назва додаваємої ноди
    const popoverName = th.dataset.sourceType;
    
    // РАННІЙ ЛОАДЕР: показуємо користувачу що щось відбувається
    // Додаємо лоадер на кнопку "+" або на полотно
    const addButton = $(th);
    const originalButtonContent = addButton.html();
    addButton.prop('disabled', true);
    addButton.html('<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Завантаження...');

    // спінер - щоб нода була вимкнута поки відправляється запрос на сервер
    const spiner =
        '<span class="spinner-wraper"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></span>';

    const futureId = "id-" + randomString(); // просто важливо щоб в майбутньому не було перетинань

    // AJAX запит для отримання ВСІХ компонентів одразу (оптимізація!)
    let eventHtml, settingsHtml, logsHtml;
    try {
        const localePrefix = getLocalePrefix();
        const response = await $.ajax({
            url: `${localePrefix}/cabinet/automatization/event/render-all/${popoverName}`,
            method: 'GET',
            dataType: 'json'
        });
        
        // Обробляємо кнопку
        const tempDiv = $('<div>').html(response.button);
        const eventEl = tempDiv.find('.event-item').first();
        eventEl.attr('id', futureId);
        eventHtml = eventEl.prop('outerHTML');
        
        // Зберігаємо HTML модалок для подальшого використання
        settingsHtml = response.settings;
        logsHtml = response.logs;
        
    } catch (error) {
        console.error('Failed to load node components:', error);
        alert(errorMessage);
        
        // Відновлюємо кнопку і розблоковуємо
        addButton.prop('disabled', false);
        addButton.html(originalButtonContent);
        isNodeCreationInProgress = false;
        
        return false;
    }

    const eventHtmlWraper = '<div class="events-item-wraper">' + eventHtml + "</div>";

    const { newX, newY } = getNewNodePosition();

    // визначаємо кількість виходів залежно від типу ноди
    const outputsCount = (popoverName === 'logic-condition') ? 2 : 1;

    // додаємо ноду на полотно
    var newNodeId = editorDrawflow.addNode(
        popoverName,
        1,
        outputsCount,
        newX,
        newY,
        popoverName,
        {},
        eventHtmlWraper
    );

    // якщо кнопка ноди успішно додана на полотно клонуємо і створюємо всі необхідні поповери
    // що викликаються з підменю для цієї ноди
    const eventItem = $("#" + futureId + ".event-item");

    // додаємо спінер (бо нижче буде відправлятися запрос на сервер щоб створити ноду) в базі
    // і тільки після цього спінер будемо видаляти
    eventItem.prepend(spiner);

    // Тепер замість виклику toggleCustomPopover (що раніше клонував),
    // просто додаємо вже завантажені HTML в DOM
    
    let settingsPopover;
    if (eventItem.length) {
        try {
            // Створюємо поповер налаштувань з завантаженого HTML
            const settingsId = "id-custom-popover-" + popoverName + "--" + randomString();
            settingsPopover = $(settingsHtml).hide().attr("id", settingsId);
            
            // Прив'язуємо ID до кнопки
            eventItem.find("[data-popover-call-name='" + popoverName + "']")
                .attr("data-custom-popover-id", settingsId);
            
            $("body").append(settingsPopover);
            
        } catch (error) {
            console.log(error);
            alert(errorMessage + "!!!");

            // видаляємо ноду з полотна і з Drawflow
            removeEvent(eventItem.find(".actions .remove-event")[0], "", false);
            
            // Відновлюємо кнопку і розблоковуємо
            addButton.prop('disabled', false);
            addButton.html(originalButtonContent);
            isNodeCreationInProgress = false;

            return false;
        }

        let new_event_id;
        // відправляєм форму - при першову відправленні - в БД створється нова пуста нода
        // використовуємо його ІД
        try {
            // якщо це перша нода що додається на полотно - то вмикаємо для неї галочку (якщо вона там є) - "повертати тільки унікальні"
            if (getNodesCount() ===1) {
                settingsPopover.find("input[type='checkbox'][name='only_uniq']").prop("checked", true);
            }

            ({ new_event_id } = await eventFormSubmit(
                settingsPopover.find("form"),
                null,
                true // skipClosePopover - не закривати попап при створенні ноди
            ));
        } catch (error) {
            console.log(error);
            alert(errorMessage);

            // видаляємо ноду з полотна і з Drawflow
            removeEvent(eventItem.find(".actions .remove-event")[0], "", false);
            // видаляємо поповер з налаштунками ноди
            settingsPopover.remove();
            
            // Відновлюємо кнопку і розблоковуємо
            addButton.prop('disabled', false);
            addButton.html(originalButtonContent);
            isNodeCreationInProgress = false;

            return false;
        }

        /**
         * на цому етапі маємо new_event_id - ІД ноди що додана в БД
         */

        // після успішного створення ноди в БД - зберігаємо реальне ІД в Drawflow
        editorDrawflow.updateNodeDataFromId(newNodeId, {
            event_id: new_event_id,
        });
        handleDrawflowChange(); // зберігаємо на сервері та у локалсторедж налаштунки полотна Drawflow

        // запускаємо функцію що заповнить нову щойно додану ноду данними що доступні для використання
        generateAvailableDataToUse();

        // ініціалізуємо залежні елементи форми
        eventsDependsSelectActivate();

        // Створюємо поповер логів з завантаженого HTML
        const logsPopoverName = popoverName + "-" + 
            (eventsSettings?.[popoverName]?.p?.log?.postfix ?? "");
        
        if (logsPopoverName) {
            const logsId = "id-custom-popover-" + logsPopoverName + "--" + randomString();
            const logsPopover = $(logsHtml).hide().attr("id", logsId);
            
            eventItem.find("[data-popover-call-name='" + logsPopoverName + "']")
                .attr("data-custom-popover-id", logsId);
            
            $("body").append(logsPopover);
        } else {
            alert("no logsPopoverName");
        }
        
        // видаляємо аякс лоадер ПІСЛЯ всіх ініціалізацій
        eventItem.find(".spinner-wraper").remove();
        
        // РОЗБЛОКУВАННЯ: відновлюємо кнопку і дозволяємо нові створення
        addButton.prop('disabled', false);
        addButton.html(originalButtonContent);
        isNodeCreationInProgress = false;
    } else {
        alert(window.i18n.generic_error);
    }
}

/**
 * в формах-налаштунках для кожної ноди - можуть зустрічатися кастомна реалізація
 * коли при виборі значення в дропдауні
 * інші поля змінюються відповідно до вибранного значення
 * ця фунція - реалізує це кастомне рішення
 */
function eventsDependsSelectActivate() {
    // Знаходимо всі форми з атрибутом data-event-form
    const forms = document.querySelectorAll("form[data-event-form]");

    forms.forEach((form) => {
        // Знаходимо всі головні залежні поля у цій формі
        const mainDepends = form.querySelectorAll("[data-main-depends]");

        mainDepends.forEach((mainDepend) => {
            const modelSelect = mainDepend.querySelector("select");
            if (!modelSelect) return;

            const mainDependAttr = mainDepend.dataset.mainDepends?.trim();
            if (!mainDependAttr) return;

            // --- ПОКРАЩЕННЯ: Переміщуємо залежні блоки в DOM так, щоб вони були одразу після батьківського поля ---
            const dependentBlocks = form.querySelectorAll(
                `[data-second-depends="${mainDependAttr}"]`
            );
            
            // Переміщуємо всі залежні блоки так, щоб вони йшли один за одним після батьківського селекта
            let lastElement = mainDepend;
            dependentBlocks.forEach((block) => {
                if (lastElement.nextSibling !== block) {
                    lastElement.after(block);
                }
                lastElement = block;
            });
            // -------------------------------------------------------------------------------------------------

            function updateDependentFields() {
                const selectedModel = modelSelect.value;

                // Використовуємо вже знайдені dependentBlocks
                dependentBlocks.forEach((block) => {
                    const dependValue = block.dataset.dependValue?.trim();
                    // Використовуємо includes() для підтримки множинних значень
                    const shouldShow =
                        dependValue &&
                        dependValue.split(",").includes(selectedModel);

                    block.style.display = shouldShow ? "" : "none";

                    // Додатково можна змінювати disabled для полів у блоці
                    const inputs = block.querySelectorAll(
                        "input, select, textarea"
                    );
                    inputs.forEach((input) => {
                        input.disabled = !shouldShow;
                    });
                });
            }

            // Додаємо обробник подій
            modelSelect.addEventListener("change", updateDependentFields);

            // Ініціалізуємо стан при завантаженні
            updateDependentFields();
        });
    });
}
window.eventsDependsSelectActivate = eventsDependsSelectActivate;

/**
 * раз в 5 секунд перевіряємо статус автоматизаціі що була запущена в ручну "запустити всю автоматизацію один раз"
 */
setInterval(() => {
    var isProcessing = false;
    if ($("#run-once-btn").hasClass("running")) {
        if (!shouldFetch) return; // Не виконуємо запит, якщо вкладка неактивна (глобальна змінна з в'ю)
        if (isProcessing) return;

        const form = $("#run-once-btn");

        var formData = [];

        formData.push({
            name: "id",
            value: form.attr("data-id"),
        });

        formData.push({
            name: "run_id",
            value: form.attr("data-run-id"),
        });

        formData.push({
            name: "_token",
            value: $('meta[name="csrf-token"]').attr("content"), // Серіалізуємо об'єкт у формат JSON
        });

        function setDefaultRunStatus() {
            form.removeClass("running");
            $("#run-once-btn .spinner-grow").remove();
            form.attr("data-run-id", "");

            // Очищаємо лог після завершення
            /*
            setTimeout(() => {
                $(".log").empty();
            }, 5000);
            */
        }

        function updateExecutionLog(tasks, run_status) {
            const logContainer = $(".bottom-actions-wrapper .log");
            if (!tasks || tasks.length === 0) {
                return;
            }

            // Функція для отримання іконки статусу
            function getStatusIcon(status) {
                switch(status) {
                    case 'success': return '✅';
                    case 'processing': return '⏳';
                    case 'pending': return '⏸️';
                    case 'error': return '❌';
                    default: return '⚪';
                }
            }

            // Функція для форматування часу
            function formatTime(ms) {
                if (!ms) return '';
                if (ms < 1000) return `${ms}ms`;
                return `${(ms / 1000).toFixed(2)}s`;
            }

            // Очищаємо контейнер
            logContainer.empty();

            // Сортуємо таски по id (від старіших до новіших)
            const sortedTasks = [...tasks].reverse();

            // Створюємо HTML для кожного таску
            let html = '<div class="execution-log">';
            sortedTasks.forEach(task => {
                if (run_status === 'success') {
                    task.status = "success";
                }

                const indent = '  '.repeat(task.depth || 0);
                const iteration = task.loop_iteration ? ` <span class="iteration">[${task.loop_iteration}]</span>` : '';
                const time = task.execution_time_ms ? ` <span class="time">(${formatTime(task.execution_time_ms)})</span>` : '';
                const statusIcon = getStatusIcon(task.status);
                
                html += `
                    <div class="log-item depth-${task.depth || 0} status-${task.status}">
                        <span class="indent">${indent}</span>
                        <span class="status-icon">${statusIcon}</span>
                        <span class="event-title">${task.event_title}</span>
                        ${iteration}
                        ${time}
                    </div>
                `;
            });
            html += '</div>';

            logContainer.html(html);
            
            // Автоматичний скрол вниз
            logContainer.scrollTop(logContainer[0].scrollHeight);
        }
    
        isProcessing = true;
        var serializedData = $.param(formData);
        $.ajax({
            url: form.attr("data-action-check-status"),
            method: "post",
            data: serializedData,
            success: function (response) {
                isProcessing = false;

                if (response.success) {
                    // Оновлюємо лог виконання
                    updateExecutionLog(response.last_tasks, response.status);

                   switch (response.status) {
                       case "pending":
                       case "processing":
                           break;
                       case "failed":
                       case "success":
                       case "cancelled":
                            // Відправляємо один останній запит через 1 секунду
                            // щоб отримати остаточний статус з БД (бо статус не завжди встигає оновитися миттєво)
                            setTimeout(() => {
                                $.ajax({
                                    url: form.attr("data-action-check-status"),
                                    method: "post",
                                    data: serializedData,
                                    success: function (finalResponse) {
                                        if (finalResponse.success) {
                                            // Оновлюємо лог з остаточними даними
                                            updateExecutionLog(finalResponse.last_tasks, finalResponse.status);
                                        }
                                        // Встановлюємо дефолтний статус після отримання фінальних даних
                                        setDefaultRunStatus();
                                    },
                                    error: function () {
                                        // Навіть якщо фінальний запит не вдався, встановлюємо дефолтний статус
                                        setDefaultRunStatus();
                                    }
                                });
                            }, 1000);
                            break;
                       default:
                            break;
                   }
                } else {
                   
                }
            },
            error: function (xhr) {
                isProcessing = false;
            },
        });
    }
}, 5000);

// Кастомні таби
document.body.addEventListener("click", function (e) {
    // Перевіряємо, чи клікнули по кнопці вкладки
    if (e.target && e.target.classList.contains("tab")) {
        const targetTab = e.target.getAttribute("data-target");
        const tabsContainer = e.target.closest(".custom-tabs"); // Знаходимо найближчий контейнер вкладок

        // Деактивуємо всі вкладки та контент всередині цього контейнера
        tabsContainer
            .querySelectorAll(".tab")
            .forEach((tab) => tab.classList.remove("active"));
        tabsContainer
            .querySelectorAll(".tab-pane")
            .forEach((pane) => pane.classList.remove("active"));

        // Активуємо поточну вкладку
        e.target.classList.add("active");

        // Показуємо відповідний контент
        tabsContainer.querySelectorAll(".tab-pane").forEach((pane) => {
            if (pane.getAttribute("data-tab") === targetTab) {
                pane.classList.add("active");
            }
        });
    }
});

/**
 * викликається раз на 5 секунд хоча по хорошему переробити на сокети в майбутньому
 *
 * бере ІД усіх нод що зараз в процесі виконання
 * оновлює їх статус раз на 5 секунд
 */
var updateEventsDataInProgress = false;
async function updateEventsData() {
    if (!shouldFetch) return; // Не виконуємо запит, якщо вкладка неактивна (глобальна змінна з в'ю)

    if (updateEventsDataInProgress) {
        return false;
    }

    // вибираємо усі ноди що запущені на полотні
    const progresEvents = $(
        "#" + drawflowId + " .event-item.in-progress[data-running-test-id]"
    );

    if (!progresEvents.length) {
        return false;
    }

    // збираємо їх айліщнікі
    const ids = [];
    progresEvents.each(function () {
        const id = $(this).attr("data-running-test-id") * 1;
        if (id) ids.push(id);
    });

    const atomatization_id = parseInt($("#automatization-id").val());
    const action = window.routes?.["event_update_data_route"]; // gloabl from view
    const data = {
        _token: $('meta[name="csrf-token"]').attr("content"), // Додаємо CSRF-токен
        ids: ids,
        atomatization_id: atomatization_id,
    };

    updateEventsDataInProgress = true;
    $.ajax({
        url: action,
        method: "POST",
        data: data,
        success: function (response) {
            if (response.success) {
                if (hasData(response.automatizations_events_tasks)) {
                    for (let k in response.automatizations_events_tasks) {
                        const eventData =
                            response.automatizations_events_tasks[k];
                        var event = $(
                            "#" +
                            drawflowId +
                            " .event-item[data-running-test-id='" +
                            eventData.task_id +
                            "']"
                        );

                        var output = eventData.output?.trim();

                        // *****************************

                        // прибираємо data-running-test-id щоб функція оновлення не обробляла цю ноду більше
                        event.removeAttr("data-running-test-id");
                        // анімаємо що він виконався
                        event.removeClass("in-progress").addClass("is-done");
                        // активуємо кнопку плей щоб можна було запустити ноду знову
                        event
                            .find(".actions .run-event svg use")
                            .attr("href", "#icon-play");
                        setTimeout(function () {
                            event.removeClass("is-done");
                        }, 1000);

                        // додаємо додаткову логіку в залежності від статусу ноди
                        switch (eventData.status) {
                            case "success":
                                break;
                            case "failed":
                                break;
                            case "skipped":
                                break;
                        }

                        // *****************************

                        if (output) {
                            // кнопка, в випадаєчему меню ноди - що показує поповер з логами
                            var showLogBtn = event.find(
                                ".actions .logs-event[data-custom-popover-id]"
                            );

                            var logId = showLogBtn.attr(
                                "data-custom-popover-id"
                            );

                            // додаємо логи виконання цих нод і данні що доступні для використання
                            var logPopoverContent = $(
                                            "#" + logId + " .content .content-inner"
                                        );

                            logPopoverContent.find("details").removeAttr("open");           

                            logPopoverContent.prepend(
                                output
                            );

                        
                            showLogBtn.click(); // показуємо поповер
                        }
                    }

                    generateAvailableDataToUse();
                }
            } else {
                if (response.message) {
                    console.log(response.message);
                }
            }

            updateEventsDataInProgress = false;
        },
        error: function (xhr) {
            if (xhr.status === 422) {
                let errors = xhr.responseJSON.errors;
                console.log(errors);
            }

            updateEventsDataInProgress = false;
        },
    });
}
setInterval(function () {
    updateEventsData();
}, 5000);

    // метод що викликається для тестової відправки повідомлення в групу на яку налаштовуюють автоматизацію
    function sendTgTestMsg(button) {
        // Отримуємо URL маршруту з атрибута data-route
        const routeName = button.dataset.route;
        const url = window.routes?.[routeName];

        if (!url) {
            console.error(`Route "${routeName}" not знайдено.`);
            return false;
        }

        // Отримуємо форму, всередині якої знаходиться кнопка
        const form = button.closest("form");
        if (!form) {
            console.error("Кнопка не знаходиться всередині форми.");
            return false;
        }

        // Створюємо об'єкт з даними форми
        const formData = new FormData(form);

        // Додаємо нове значення:
        formData.append("set_tg_link", "1");

        // Відправляємо POST-запит
        fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrfToken,
            },
            body: formData,
        })
            .then(async (response) => {
                // Якщо статус не 2xx — кидаємо помилку з текстом від сервера
                if (!response.ok) {
                    const errorData = await response.json();
                    throw errorData;
                }

                return response.json(); // для успішної відповіді
            })
            .then((result) => {
                if (result.message) {
                    alert(result.message);
                }
            })
            .catch((errorData) => {
                console.log("Помилка:", errorData);

                // Якщо це об'єкт з помилками валідації
                if (errorData.errors) {
                    showFormErrors($(form), errorData.errors);
                } else {
                    console.log(errorData);
                }
            });

        return false; // запобігаємо перезавантаженню сторінки
    }
    window.sendTgTestMsg = sendTgTestMsg;

    /*
    let isDragging = false;
    $(document).on("mousedown", function (e) {
        isDragging = false; // Початкове значення
    });

    $(document).on("mousemove", function (e) {
        isDragging = true; // Якщо є рух миші після натискання — це drag
    });

    // Закриваємо кастомний поповер при кліці за кордонами поповера
    $(document).on("mouseup", function (e) {
        if (isDragging) return false;

        var $popover = $(".custom-popover");
        var target = $(e.target);

        // Перевіряємо чи не клікнули на сам поповер або на тригер (включаючи кнопку)
        if (
            !$popover.is(target) &&
            $popover.has(target).length === 0 &&
            !$(target).closest("[data-call-custom-popover]").length
        ) {
            if ($popover.hasClass("show")) {
                $popover.removeClass("show");
            } else {
                $popover.fadeOut(animateTime);
            }

            $popover.removeAttr("data-open");
        }
    });
    */

    // Закриваємо всі кастомні поповери при натисканні ESC
    $(document).on("keydown", function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            var $popovers = $(".custom-popover:visible");
            
            if ($popovers.length > 0) {
                $popovers.each(function() {
                    var $popover = $(this);
                    
                    if ($popover.hasClass("show")) {
                        $popover.removeClass("show");
                    } else {
                        $popover.fadeOut(animateTime);
                    }
                    
                    $popover.removeAttr("data-open");
                });
            }
        }
    });

     /** клонує fieldset у ноді REST API */
    function cloneFildset(th) {
        let fieldset = th.closest("fieldset"); // Знаходимо найближчий fieldset
        if (!fieldset) return; // Якщо fieldset не знайдено, вихід

        let clone = fieldset.cloneNode(true); // Клонуємо fieldset разом із усім вмістом

        // Очищаємо всі поля форми в клонованому fieldset
        clone.querySelectorAll("input, textarea, select").forEach((el) => {
            if (el.type === "checkbox" || el.type === "radio") {
                el.checked = false; // Скидаємо чекбокси та радіокнопки
            } else {
                el.value = ""; // Очищаємо текстові поля, textarea, select
            }
        });

        let parent = fieldset.closest(".fieldset-group"); // Знаходимо батьківський елемент з класом .fieldset-group
        if (parent) {
            parent.appendChild(clone); // Додаємо клон у кінець батьківського елемента

            // Плавне прокручування до щойно доданого елемента
            clone.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }
    window.cloneFildset = cloneFildset;



    // збереження даних про посилання на групу телеграм на яку налаштована автоматизація
    var dataTelegramLinkToPostSubmitInterval;
    $("body").on("input", "[data-telegram-link-to-post]", function () {
        clearTimeout(dataTelegramLinkToPostSubmitInterval);

        const th = $(this);

        // не виконуємо логіку для дефолтних модальних вікон
        const defaultModals = th.closest("#events-default-popovers-wrap");
        if (defaultModals.length) return false;

        const v = $.trim(th.val());
        const hashInputName = $.trim(th.attr("data-telegram-link-to-post"));
        const form = th.closest("form");
        const hashInput = form.find("[name='" + hashInputName + "']").eq(0);
        const clip = form.find(
            "[data-clipboard-text][data-name='" + hashInputName + "']"
        );
        if (!clip || !clip.length) return false;

        // Функція для відправки даних
        const submitFormData = (formData) => {
            const hashItem = formData.find((item) => item.name === "uniq_hash");
            const hash = hashItem?.value;
            
            // Надсилаємо через AJAX
            if (hash) {
                dataTelegramLinkToPostSubmitInterval = setTimeout(function () {
                    th.attr("disabled", "disabled");

                    $.ajax({
                        url: form.attr("action"),
                        method: form.attr("method"),
                        data: formData,
                        success: function (response) {
                            form.find(".invalid-feedback").html("");
                            form.find(".is-invalid").removeClass("is-invalid");
                            th.removeAttr("disabled");
                            th.focus();
                        },
                        error: function (xhr) {
                            let errors = xhr.responseJSON.errors;
                            console.log("Помилка:", xhr.responseText);

                            showFormErrors(form, errors);
                            th.removeAttr("disabled");
                            th.focus();
                        },
                    });
                }, 1000);
            }
        };

        if (v) {
            customShortHash(userHash + " " + v).then((hash) => {
                hashInput.val(hash);

                //clip.closest(".copy-to-clipboard-wrap").show();
                clip.attr("data-clipboard-text", "/tglist_" + hash);
                clip.find(".command").html("/tglist_" + hash);
                
                const formData = form.serializeArray();
                formData.push({ name: "set_tg_link", value: "1" });
                
                // Відправляємо дані після того як hash готовий
                submitFormData(formData);
            });
        } else {
            hashInput.val("");

            //clip.closest(".copy-to-clipboard-wrap").hide();
            const clipMsg = clip.attr("data-no-command-message");
            clip.attr("data-clipboard-text", "");
            clip.find(".command").html("<b>" + clipMsg + "</b>");
            
            const formData = form.serializeArray();
            formData.push({ name: "set_tg_link", value: "1" });
            
            // Відправляємо дані одразу
            submitFormData(formData);
        }
    });
    
    setTimeout(() => {
        $("[data-telegram-link-to-post]").trigger("input");
    }, 4000);

    // копія метода в моделі юзера що генерує хещ
    function customShortHash(input, length = 8) {
        const alphabet = availableHash; // global
        const encoder = new TextEncoder();
        const data = encoder.encode(input + "fixed_salt");

        return crypto.subtle.digest("SHA-256", data).then((hashBuffer) => {
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            let result = "";
            for (let i = 0; i < length; i++) {
                const byte = hashArray[i % hashArray.length];
                result += alphabet[byte % alphabet.length];
            }
            return result;
        });
    }

    /** запускає автоматизацію на тестуавння - кнлпка "запустити один раз" */
    function runAutomatizationOnes(button) {
        if (hasBrokeDrawflow()) {
            alert(window.i18n.nodes_must_be_connected);
            return;
        }

        const form = $(button);
        
        // Блокуємо кнопку на час виконання запиту
        form.attr("disabled", "disabled");
        
        // Очищаємо лог та встановлюємо текст за замовчуванням перед запуском
        const logContainer = $(".bottom-actions-wrapper .log");
        logContainer.empty();
        const defaultText = logContainer.attr("data-text-default");
        if (defaultText) {
            logContainer.html(`<span class="text-muted">${defaultText}</span>`);
        }
        var status = form.hasClass("running");
        var initialStatus = status; // Зберігаємо початковий стан для відновлення при помилці
        form.find(".spinner-grow").remove();

        if (!status) {
            form
                .find(" > div")
                .append(
                    '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
                );
            form.addClass("running");
            
            // Очищаємо лог при запуску
            $(".bottom-actions-wrapper .log").empty();
            
        } else {
            form.removeClass("running");
            $("#run-once-btn .spinner-grow").remove();
            
            // Відновлюємо дефолтний текст при зупинці вручну
            const logContainer = $(".bottom-actions-wrapper .log");
            const defaultText = logContainer.attr("data-text-default");
            if (defaultText) {
                logContainer.html(`<span class="text-muted">${defaultText}</span>`);
            }
        }

        var formData = [];

        formData.push({
            name: "id",
            value: form.attr("data-id"),
        });

        formData.push({
            name: "_token",
            value: $('meta[name="csrf-token"]').attr("content"), // Серіалізуємо об'єкт у формат JSON
        });

    
        var serializedData = $.param(formData);
        $.ajax({
            url: form.attr("data-action"),
            method: "post",
            data: serializedData,
            success: function (response) {
                if (response.success) {
                    status = !status;
                    
                } else {
                    if (response.message) {
                        alert(response.message);
                    } else {
                        alert(
                            "Сталася помилка, будь ласка повторіть спробу пізніше"
                        );
                    }
                }

                form.find(".spinner-grow").remove();
                if (status) {
                    form
                        .find(" > div")
                        .append(
                            '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
                        );
                    form.addClass("running");

                    if (response.run_id) {
                        form.attr("data-run-id", response.run_id);
                    }
                } else {
                    form.removeClass("running");
                    $("#run-once-btn .spinner-grow").remove();
                    form.attr("data-run-id", "");
                }
                
                // Розблокуємо кнопку після завершення запиту
                form.removeAttr("disabled");
            },
            error: function (xhr) {
                form.find(".spinner-grow").remove();
                
                // Відновлюємо початковий стан при помилці
                if (initialStatus) {
                    // Якщо була запущена - повертаємо running стан
                    form.addClass("running");
                    form.find(" > div").append(
                        '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>'
                    );
                } else {
                    // Якщо не була запущена - залишаємо зупиненою
                    form.removeClass("running");
                    $("#run-once-btn .spinner-grow").remove();
                    form.attr("data-run-id", "");
                }

                alert(window.i18n.error_try_later);

                if (xhr.status === 422) {
                    let errors = xhr.responseJSON.errors;
                    console.log(errors);
                }
                
                // Розблокуємо кнопку після помилки
                form.removeAttr("disabled");
            },
        });

        return false;
    }
    window.runAutomatizationOnes = runAutomatizationOnes;
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
// NODES LOGIC
var drawflowСontainer = document.getElementById(drawflowId);

// ініціалізація полотна для додавання нод, драгінгу і тд
const editorDrawflow = new Drawflow(drawflowСontainer);
editorDrawflow.start();
window.editorDrawflow = editorDrawflow;


/*
// вимикаємо меню при правому кліці
drawflowСontainer.addEventListener(
    "contextmenu",
    (e) => {
        e.stopPropagation();
        e.preventDefault();
    },
    true // ← важливо! режим перехоплення (capturing)
);
*/

// обробка кнопки замочка на полотні внизу
function changeMode(option) {
    if (option == "lock") {
        lock.style.display = "none";
        unlock.style.display = "block";
    } else {
        lock.style.display = "block";
        unlock.style.display = "none";
    }
}
window.changeMode = changeMode;

// при додавання ноди на полотно - об'єднуємо її зв'язком з нодою - для якої вона додається в ланцюжку
editorDrawflow.on("nodeCreated", function (id) {
    if (window.parent_plus_node_id) {
        const idFrom = window.parent_plus_node_id.match(/\d+/)[0]; // "1"
            editorDrawflow.addConnection(idFrom, id, "output_" + window.parent_plus_node_output_id, "input_1");
        window.parent_plus_node_id = 0;
    }
});

// Видаляємо .parent-node, якщо ноду всередині було видалено через Drawflow (хрестик або Delete)
editorDrawflow.on("nodeRemoved", function (id) {
    $('.parent-node').each(function() {
        if ($(this).find('.drawflow-node').length === 0) {
            $(this).remove();
        }
    });
    handleDrawflowChange();
});

// === Серверне збереження з debounce і чергою ===
let serverSavingDrawflowInProgress = false;
let saveDrawflowTimeout = null;
const SAVE_DELAY = 1000; // затримка 1 сек після останньої зміни

// === Safe localStorage ===
function safeLocalStorageSet(key, value) {
    if (window.disableDrawflowCache) return;
    try {
        localStorage.setItem(key, value);
    } catch (e) {
        console.warn("localStorage не доступний:", e);
    }
}
function safeLocalStorageGet(key) {
    if (window.disableDrawflowCache) return null;
    try {
        return localStorage.getItem(key);
    } catch (e) {
        console.warn("localStorage не доступний:", e);
        return null;
    }
}

// === Helper to detect cycles (excluding a specific connection) ===
function hasPathExcluding(sourceId, targetId, excludeSrc, excludeOutput, excludeTgt, excludeInput, visited = new Set()) {
    try {
        sourceId = String(sourceId);
        targetId = String(targetId);
        excludeSrc = String(excludeSrc);
        excludeTgt = String(excludeTgt);
        
        if (sourceId === targetId) return true;
        
        if (visited.has(sourceId)) return false;
        visited.add(sourceId);
        
        const moduleName = editorDrawflow.module;
        if (!editorDrawflow.drawflow[moduleName]) return false;
        
        const nodes = editorDrawflow.drawflow[moduleName].data;
        if (!nodes) return false;

        const node = nodes[sourceId];
        if (!node) return false;
        
        for (const outName in node.outputs) {
            const connections = node.outputs[outName].connections || [];
            for (const conn of connections) {
                const nextId = String(conn.node);
                
                // Skip the connection we're currently adding
                if (sourceId === excludeSrc && outName === excludeOutput && nextId === excludeTgt) {
                    continue;
                }
                
                if (hasPathExcluding(nextId, targetId, excludeSrc, excludeOutput, excludeTgt, excludeInput, visited)) {
                    return true;
                }
            }
        }
    } catch (e) {
        console.error("Error in hasPathExcluding:", e);
        return false;
    }
    return false;
}

// === Helper to detect cycles ===
function hasPath(sourceId, targetId, visited = new Set()) {
    try {
        sourceId = String(sourceId);
        targetId = String(targetId);
        
        if (sourceId === targetId) return true;
        
        if (visited.has(sourceId)) return false;
        visited.add(sourceId);
        
        // Use Drawflow API instead of direct data access
        const node = editorDrawflow.getNodeFromId(sourceId);
        
        if (!node) return false;
        
        for (const outName in node.outputs) {
            const connections = node.outputs[outName].connections || [];
            for (const conn of connections) {
                const nextId = String(conn.node);
                if (hasPath(nextId, targetId, visited)) return true;
            }
        }
    } catch (e) {
        console.error("Error in hasPath:", e);
        return false; // Fail safe: allow connection if check fails
    }
    return false;
}

// Prevent creating cycles (connecting to previous nodes)
editorDrawflow.on('connectionCreated', function (connection) {
    try {
        // console.log("Debug: connectionCreated triggered");
        if (!connection) {
            console.warn("Debug: connection object is missing");
            return;
        }
        
        // Drawflow connection object structure:
        // { output_id: "1", input_id: "2", output_class: "output_1", input_class: "input_1" }
        // OR sometimes it might be passed differently depending on version.
        // Let's try to handle both common patterns or log what we get.
        
        const src = String(connection.output_id || connection.outputNode);
        const tgt = String(connection.input_id || connection.inputNode);

        // console.log(`Debug: Checking connection ${src} -> ${tgt}`, connection);

        if (src === tgt) {
            console.warn(window.i18n.self_connection_forbidden + ':', src, '->', tgt);
            // Check if removeSingleConnection exists
            if (typeof editorDrawflow.removeSingleConnection === 'function') {
                // Defer removal to avoid conflict with current event processing
                setTimeout(() => {
                    try {
                        editorDrawflow.removeSingleConnection(src, connection.output_class, tgt, connection.input_class);
                    } catch (err) {
                        console.error("Error removing self-connection:", err);
                    }
                }, 10);
            } else {
                console.error("Debug: removeSingleConnection is not a function");
            }
            return;
        }

        // CRITICAL: When this event fires, Drawflow has ALREADY added the connection.
        // We need to check if there was a path from tgt to src BEFORE adding this connection.
        // To do this, we temporarily remove the new connection, check for path, then restore it.
        
        // Get the output class name (e.g., "output_1")
        const outputClass = connection.output_class;
        const inputClass = connection.input_class;
        
        // Temporarily remove the newly added connection
        // Use Drawflow's API to get the node
        let sourceNode = editorDrawflow.getNodeFromId(src);
        
        if (sourceNode && sourceNode.outputs && sourceNode.outputs[outputClass]) {
            const connections = sourceNode.outputs[outputClass].connections;
            const connectionIndex = connections.findIndex(c => String(c.node) === tgt);
            
            if (connectionIndex !== -1) {
                // Remove the connection temporarily
                const removedConnection = connections.splice(connectionIndex, 1)[0];
                
                // Now check if there's still a path from tgt to src
                const createsCycle = hasPath(tgt, src);
                
                // Restore the connection
                connections.splice(connectionIndex, 0, removedConnection);
                
                if (createsCycle) {
                    console.warn(window.i18n.cycle_connection_forbidden);
                    
                    // Restore the connection first (we removed it for checking)
                    connections.splice(connectionIndex, 0, removedConnection);
                    
                    // Now use Drawflow's API to properly remove it
                    // removeSingleConnection(id_output, id_input, output_class, input_class)
                    editorDrawflow.removeSingleConnection(src, tgt, outputClass, inputClass);
                } else {
                    // No cycle - connection is already restored above
                }
            }
        }
    } catch (e) {
        console.error("Error in connectionCreated handler:", e);
        console.error("Stack:", e.stack);
    }
});

// === Ключі ===
function getLocalDataKey(id) {
    return `editorDrawflowData_${id}`;
}

const events = [
    // "nodeCreated", // викликається вручну в середені addNode()
    "nodeMoved",
    "connectionCreated",
    "connectionRemoved",
    "nodeDataChanged",
    "nodeRemoved",
];
events.forEach((evt) => editorDrawflow.on(evt, handleDrawflowChange));

/**
 * Завантаження стану полотна Drawflow при старті сторінки
 */
window.addEventListener("DOMContentLoaded", async () => {
    // пробуємо взяти актуальну версію з локалсторендж
    const savedData = safeLocalStorageGet(
        getLocalDataKey(recordId + "." + userId)
    );

    editorDrawflow.on('import', async function (id) {
        await createAllNodesPopovers();

        generateAvailableDataToUse();

        // Центруємо вигляд на нодах
        setTimeout(centerDrawflowView, 100);
    });

// === Helper to clean invalid connections ===
function cleanDrawflowData(data) {
    if (!data || !data.drawflow || !data.drawflow.Home || !data.drawflow.Home.data) {
        return data;
    }

    const nodes = data.drawflow.Home.data;
    const nodeIds = new Set(Object.keys(nodes).map(String));

    for (const nodeId in nodes) {
        const node = nodes[nodeId];
        
        // Clean inputs
        for (const inputName in node.inputs) {
            const input = node.inputs[inputName];
            if (input.connections) {
                input.connections = input.connections.filter(conn => nodeIds.has(String(conn.node)));
            }
        }

        // Clean outputs
        for (const outputName in node.outputs) {
            const output = node.outputs[outputName];
            if (output.connections) {
                output.connections = output.connections.filter(conn => nodeIds.has(String(conn.node)));
            }
        }
    }
    return data;
}

    // якщо в локалсторендж нема але є в БД
    var hasDataFlag = true;

    // Перевіряємо чи DBdrawflowSettings не порожній об'єкт
    if (hasData(DBdrawflowSettings) && !savedData) {
        const cleanedData = cleanDrawflowData(DBdrawflowSettings);
        
        editorDrawflow.import(cleanedData);
        handleDrawflowChange(true, false);
    } else if (savedData) {
        const parsedData = JSON.parse(savedData);
        const cleanedData = cleanDrawflowData(parsedData);
        editorDrawflow.import(cleanedData);
    } else {
        hasDataFlag = false;
        await createAllNodesPopovers();
    }

    /**
     * перевіряємо чи потребує Drawflow збереження у БД на сервері
     * при оновленні сторінки
     */
    const serverFlagKey = getServerDrawflowFlagKey(recordId + "." + userId);
    const flag = safeLocalStorageGet(serverFlagKey);

    // ВАЖЛИВА ПЕРЕВІРКА: виявляємо невідповідність між localStorage і сервером
    // Якщо в localStorage є дані і флаг каже що вони збережені на сервері,
    // але насправді на сервері (DBdrawflowSettings) даних немає - треба перезберегти
    const hasLocalStorageData = savedData && hasDataFlag;
    const serverIsEmpty = !hasData(DBdrawflowSettings);
    const flagSaysServerSaved = flag === "true";
    
    if (hasLocalStorageData && serverIsEmpty && flagSaysServerSaved) {
        // Виявлено невідповідність: localStorage має дані, але сервер порожній
        console.warn("⚠️ Виявлено невідповідність: localStorage має дані, але сервер порожній. Перезбереження на сервер...");
        
        // КРИТИЧНО: скидаємо флаг на "pending", щоб processDrawflowServerSave не пропустила запит
        safeLocalStorageSet(serverFlagKey, "pending");
        
        handleDrawflowChange(false, true);
    } else if (
        hasDataFlag &&
        !serverSavingDrawflowInProgress &&
        (flag !== "true" || !flag)
    ) {
        handleDrawflowChange(false, true);
    }
});

/**
 * за замовчуванням намагаємося зберегти данні Drawflow стана полотна
 * на сервері в БД - кожну 1 секунду
 * там є перевірка - чи будв змінений стан чи ні - і якщо стан змінений - то буде зберігання
 */
function scheduleServerSave() {
    clearTimeout(saveDrawflowTimeout);
    saveDrawflowTimeout = setTimeout(processDrawflowServerSave, SAVE_DELAY);
}

function getServerDrawflowFlagKey(id) {
    return `editorDrawflowServer_${id}`;
}

/**
 * функція зберігає Drawflow данні стана полотна на сервері в БД
 */
async function processDrawflowServerSave() {
    const serverFlagKey = getServerDrawflowFlagKey(recordId + "." + userId);
    const flag = safeLocalStorageGet(serverFlagKey);

    if (serverSavingDrawflowInProgress || flag === "true") {
        return;
    }

    serverSavingDrawflowInProgress = true;

    const dataKey = getLocalDataKey(recordId + "." + userId);
    const localData = safeLocalStorageGet(dataKey);
    if (!localData) {
        serverSavingDrawflowInProgress = false;
        return;
    }


    try {
        const response = await fetch(window.routes.save_drawflow, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": csrfToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ recordId, data: JSON.parse(localData) }),
        });

        if (response.ok) {
            const data = await response.json();

            if (data.success) {
                safeLocalStorageSet(serverFlagKey, "true");
            } else {
                safeLocalStorageSet(serverFlagKey, "pending");
            }
        } else {
            safeLocalStorageSet(serverFlagKey, "pending");
        }
    } catch (e) {
        safeLocalStorageSet(serverFlagKey, "pending");
    } finally {
        serverSavingDrawflowInProgress = false;
        // Якщо під час запиту з’явилися нові зміни, одразу спробуємо ще раз
        const newFlag = safeLocalStorageGet(serverFlagKey);
        if (newFlag === "pending") scheduleServerSave();
    }
}

/**
 * Збереження локально + статус для сервера
 */
function saveDrawflowLocally() {
    const data = editorDrawflow.export();

    const dataKey = getLocalDataKey(recordId + "." + userId);
    safeLocalStorageSet(dataKey, JSON.stringify(data));
    safeLocalStorageSet(
        getServerDrawflowFlagKey(recordId + "." + userId),
        "pending"
    );
}

/**
 * Виклик при будь-якій зміні нод або в ручну наприклад
 * після відправки аякс запроса на створення ІД ноди в БД
 */
/**
 * Центрує вигляд Drawflow на наявних нодах
 */
function centerDrawflowView() {
    if (!editorDrawflow || !editorDrawflow.drawflow) return;

    const moduleName = editorDrawflow.module;
    
    let nodesData = null;
    if (editorDrawflow.drawflow[moduleName]) {
        nodesData = editorDrawflow.drawflow[moduleName].data;
    } else if (editorDrawflow.drawflow.drawflow && editorDrawflow.drawflow.drawflow[moduleName]) {
        nodesData = editorDrawflow.drawflow.drawflow[moduleName].data;
    }

    if (!nodesData) {
        setTimeout(centerDrawflowView, 100);
        return;
    }
    const nodeIds = Object.keys(nodesData);

    if (nodeIds.length === 0) return;

    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;

    nodeIds.forEach(id => {
        const node = nodesData[id];
        const x = node.pos_x;
        const y = node.pos_y;
        
        // Спробуємо отримати розміри з DOM
        const nodeEl = document.getElementById("node-" + id);
        const width = nodeEl ? nodeEl.offsetWidth : 200; 
        const height = nodeEl ? nodeEl.offsetHeight : 100;

        if (x < minX) minX = x;
        if (x + width > maxX) maxX = x + width;
        if (y < minY) minY = y;
        if (y + height > maxY) maxY = y + height;
    });

    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;

    const container = document.getElementById(drawflowId);
    if (!container) return;
    
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    
    if (containerWidth === 0 || containerHeight === 0) {
        setTimeout(centerDrawflowView, 100);
        return;
    }
    
    const zoom = editorDrawflow.zoom;
    
    // canvas_x = (containerWidth / 2) - (centerX * zoom)
    const newCanvasX = (containerWidth / 2) - (centerX * zoom);
    const newCanvasY = (containerHeight / 2) - (centerY * zoom);

    editorDrawflow.canvas_x = newCanvasX;
    editorDrawflow.canvas_y = newCanvasY;
    
    // Спробуємо оновити через метод бібліотеки
    if (typeof editorDrawflow.updateCanvas === 'function') {
        editorDrawflow.updateCanvas();
    } else {
        // Якщо методу немає, спробуємо вручну
        // Зазвичай Drawflow використовує .drawflow .parent-node або .drawflow
        // Але в стандартній версії це .drawflow
        // Перевіримо структуру
        const precanvas = container.querySelector(".drawflow");
        if (precanvas) {
            precanvas.style.transform = "translate(" + newCanvasX + "px, " + newCanvasY + "px) scale(" + zoom + ")";
        }
    }
}
window.centerDrawflowView = centerDrawflowView;

function handleDrawflowChange(localy = true, server = true) {
    if (localy) saveDrawflowLocally();
    if (server) scheduleServerSave();
}

async function createAllNodesPopovers() {
    // проходимо по всім нодам і створюємо для них всі поповери що треба
    // з налаштунками/ з логами і тд
    // вони вже є в домі просто немає зв'язку по data-custom-popover-id
    // бо ще не було виклику
    $(
        "#" + drawflowId + " .drawflow .event-item [data-call-custom-popover]"
    ).each(function () {
        var th = $(this);
        var attr = th.attr("data-custom-popover-id");
        var name = th.attr("data-popover-call-name");
        if (!attr && name) {
            toggleCustomPopover(
                th[0],
                th.attr("data-popover-call-name"),
                false
            );
        }
    });

    //-------------------------------------------
    // вмикаємо кнопку "плей" для усізх нод що в стані "виконується"
    // runningTestNodes - глобальна змінна
    for (let nodeId in runningTestNodes) {
        var event = $("#" + drawflowId + " #node-" + nodeId + " .event-item");
        // запускаємо анімацію що ноду запущено
        event.addClass("in-progress");
        // змінюємо іконку на кнопку "стоп"
        var runBtn = event.find(".actions .run-event");
        runBtn.find("svg use").attr("href", "#stop-icon");

        event.attr("data-running-test-id", runningTestNodes[nodeId]);
    }
}

/**
 * Закриття модалок допомоги при кліку поза ними.
 * Це замінює onclick="event.stopPropagation()" на самій модалці,
 * дозволяючи подіям (наприклад, перемикання табів) спливати до document.body.
 */
document.body.addEventListener("click", function (e) {
    // Якщо клік був по кнопці відкриття модалки - нічого не робимо (там своя логіка)
    if (e.target.closest(".show-help-modal-ajax")) {
        return;
    }

    // Якщо клік всередині модалки допомоги - нічого не робимо
    if (e.target.closest(".custom-popover.help-modal-type")) {
        return;
    }

    // Інакше закриваємо всі відкриті модалки допомоги
    const helpModals = document.querySelectorAll(".custom-popover.help-modal-type.show");
    if (helpModals.length > 0) {
        $(helpModals).removeClass("show").fadeOut(200);
    }
});

/**
 * Обробка кліку на кнопку допомоги (знак питання)
 * Завантажує модалку через AJAX при першому кліку, потім показує з кешу (DOM)
 */
$("body").on("click", ".show-help-modal-ajax", async function (e) {
    e.preventDefault();
    e.stopPropagation();

    const btn = $(this);
    const eventName = btn.data("help-event-name");
    let fieldName = btn.data("help-field-name");

    console.log('Help click:', { eventName, fieldName });

    if (!eventName || !fieldName) {
        console.error("Missing eventName or fieldName for help modal");
        return;
    }

    // Очищуємо ім'я поля від індексів репітера і дужок для бекенду
    // items[0][title] -> items.title
    const cleanFieldName = fieldName
        .replace(/\[\d+\]/g, '') // видаляємо індекси [0]
        .replace(/\[/g, '.')     // замінюємо [ на .
        .replace(/\]/g, '');     // видаляємо ]

    // ID для кешування в DOM
    // Використовуємо повне ім'я поля (з індексами), щоб для кожного інпуту була своя модалка (якщо там різний контент? ні, контент однаковий для типу поля)
    // АЛЕ, якщо ми хочемо кешувати "тип" підказки, то краще використовувати cleanFieldName.
    // Якщо контент підказки статичний для поля конфігу -> використовуємо cleanFieldName.
    const modalId = "help-modal-" + eventName + "-" + cleanFieldName.replace(/\./g, '-');
    
    // Перевіряємо чи є вже така модалка в DOM
    let modal = $("#" + modalId);

    if (modal.length) {
        // Якщо є - просто перемикаємо
        if (modal.hasClass("show")) {
            // Закриваємо тільки цю модалку
             modal.removeClass("show").fadeOut(200);
        } else {
             // Закриваємо інші модалки підказок (але не налаштувань)
             $(".custom-popover.help-modal-type.show").not(modal).removeClass("show").fadeOut(200);
             
             modal.css("display", "flex").fadeIn(200).addClass("show");
        }
        return;
    }

    // Якщо немає - вантажимо
    const originalContent = btn.html();
    // Спінер
    btn.html('<span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>');
    btn.addClass('disabled').prop('disabled', true);

    try {
        const localePrefix = getLocalePrefix();
        const response = await $.ajax({
            url: `${localePrefix}/cabinet/automatization/event/render-help/${eventName}/${cleanFieldName}`,
            method: 'GET',
            dataType: 'json'
        });

        if (response.html) {
            // Створюємо елемент
            modal = $(response.html);
            modal.attr("id", modalId);
            modal.hide();
            
            $("body").append(modal);

            // Закриваємо інші модалки підказок
            $(".custom-popover.help-modal-type.show").removeClass("show").fadeOut(200);
            
            // Показуємо
            modal.css("display", "flex").fadeIn(200).addClass("show");
            
            // Re-init close button behavior for this specific modal
             modal.find('button[onclick="closePopover(this);"]').attr('onclick', '').click(function() {
                 $(this).closest('.custom-popover').removeClass("show").fadeOut(200);
             });
        }

    } catch (error) {
        console.error("Failed to load help modal:", error);
        // Можна показати тост помилки
    } finally {
        // Відновлюємо кнопку
        btn.html(originalContent);
        btn.removeClass('disabled').prop('disabled', false);
    }
});
